import React from "react";

const DropDown = ({
  items = [],
  onPress = () => {},
  value = "",
  placeholder = "Select City",
}) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onPress(selectedValue);
  };

  return (
    <div className="select-location">
      <select
        className="form-control"
        value={value || ""}
        onChange={handleChange}
      >
        {/* Placeholder */}
        <option value="" disabled>
          {placeholder}
        </option>

        {items.map((item, index) => {
          const cityName =
            typeof item === "string"
              ? item
              : item?.name || "";

          return (
            <option
              key={`${cityName}-${index}`}
              value={cityName}
            >
              {cityName}
            </option>
          );
        })}
      </select>

      <span>
        <i className="fa fa-angle-down"></i>
      </span>
    </div>
  );
};

export default DropDown;